<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }} <span v-if="required">*</span> :</label>
    <input style="height:42px" :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" :type="type" :max="dateNotInFuture ? maxDate : ''" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
    <hint :hint="hint"></hint>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Hint from '@/Shared/Hint'

export default {
  inheritAttrs: false,
  components: {Hint},
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: String,
    hint: String,
    required: Boolean,
    dateNotInFuture: {
      type: Boolean,
      default: false
    },
    minYear: {
      type: Number,
      default: 0,
    }
  },
  emits: ['update:modelValue'],
  computed:{
    maxDate(){
      const date = new Date()
      const newDate = new Date(date.setFullYear(date.getFullYear() - this.minYear))
      return newDate.toISOString().slice(0, 10)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
<style scoped>
input::placeholder{
  color:#adadad;
  font-size: 14px;
}
</style>
